require("./advertplatform.scss");
export class AdvertPlatform {
    loadAdverts = () => {
        this.loadGoogleMrec();
    }

    loadGoogleMrec() {
        googletag.cmd.push(() => this.loadGoogleAdverts());
    }

    getSizes(strSizes) {
        if (!strSizes) return [];
        return strSizes.split(",").map(x => x.split("x").map(y => {
            const parsed = parseInt(y);
            return isNaN(parsed) ? y : parsed;
        }));
    }

    getAdTags(strTags) {
        if (!strTags) return [];
        return strTags.split("|").map(x => x.split(","));
    }

    getKruxParam(strKrux, paramName) {
        if (!strKrux) return '';
        var vars = strKrux.split("/");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == paramName) {
                return pair[1];
            }
        }
        return null;
    }

    getKruxTags() {
        var kruxSasHelper = window.KruxSasHelper;
        if (kruxSasHelper) {
            var sasTags = kruxSasHelper().getSasTags();
            return {
                "ksg": this.getKruxParam(sasTags, "ksg"),
                "kuid": this.getKruxParam(sasTags, "kuid"),
                "gaclientId": this.getKruxParam(kruxSasHelper().getGaTags(), "gaclientId")
            };
        }

        console.warn("KruxSasHelper not loaded");
        return {};
    }

    getQueryParam(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return null;
    }

    getTitle() {
        // Extract article title from last section of url
        var sections = window.location.pathname.split('/');
        var title = "";
        while (sections.length > 0 && title === "") {
            title = sections.pop();
        }
        return title;
    }

    getGoogleAdverts() {
        let criteria = ($("div[data-ad-path]").length > 0) ? 'div[data-ad-path]' : 'div[data-fuse]';
        return $(criteria).map((index, elm) => {
            var target = $(elm);
            var path = target.data("adPath");
            var tags = target.data("adTags");
            var tileData = window.google_advert_tile_data || false;
            if (window.csnGoogleAdvertData) {
                var tile = target.data('ad-tile');
                if (tile) {
                    var newPath = window.csnGoogleAdvertData[`tile${tile}`];
                    if (newPath) {
                        path = newPath;
                    }
                }
            }

            if (tileData) {
                var tile = target.data('ad-tile');
                if (tile) {
                    var data = tileData[`tile${tile}`];
                    if (data) {
                        path = data.path;
                        tags = data.tags;
                        if (data.id) {
                            $(elm).attr("id", data.id);
                        }
                    }
                }
            }
            return {
                targetId: $(elm).attr("id"),
                path: path,
                sizes: this.getSizes($(elm).data("adReplaceSize") || $(elm).data("adSizes")),
                tags: this.getAdTags(tags),
                outOfPage: String(target.data('adOutOfPage')).toLowerCase() === "true"
            };
        }).get();
    }

    loadGoogleAdverts() {
        if ($('div[data-fuse]').length > 0) return;
        const adverts = this.getGoogleAdverts();
        const pubads = googletag.pubads();
        pubads.addEventListener('slotRenderEnded', function (event) {
            var slot = event.slot;
            let adElement = document.getElementById(slot.getSlotElementId());
            adElement.classList.add(event.isEmpty ? "no-ad-loaded" : "ad-loaded");
            if (!event.isEmpty) {
                let fallbackElement = document.getElementById(adElement.id + "_fallback");
                if (fallbackElement) {
                    fallbackElement.classList.add("ad-loaded");
                    window.setTimeout(() => {
                        fallbackElement.remove();
                    }, 0);
                }
            }
        });
        
        const memberId = (window.google_advert_member_id || false);
        const enableLazyLoad = window.google_advert_enable_lazy_load;
        const adTags = (window.google_advert_targeting_tags || {});
        // Make sure previous slots are destroyed
        googletag.destroySlots();
        //  Define slots
        for (let ad of adverts) {
            const slot = ad.outOfPage === true
                ? googletag.defineOutOfPageSlot(ad.path, ad.targetId)
                : googletag.defineSlot(ad.path, ad.sizes, ad.targetId);

            //  ad level targeting
            if (ad.tags) {
                ad.tags.forEach(tag => {
                    if (tag.length === 2)
                        slot.setTargeting(tag[0], tag[1]);
                });
            }

            slot.addService(pubads);
        }

        // Set CSNClientId from cookie
        const csnclientidCookie = document.cookie.split('; ').find(row => row.startsWith('csnclientid'));
        let csnClientId = '';
        if (csnclientidCookie) {
            csnClientId = csnclientidCookie.split('=')[1];
        }
        pubads.setPublisherProvidedId(csnClientId);

        // Set page-level key-values and GPT settings
        pubads.setTargeting('title', [this.getTitle()])
            .setTargeting("adtest", [this.getQueryParam("adtest") || "false"]);

        //  Set targetting
        for (let key in adTags) {
            if (adTags.hasOwnProperty(key)) {
                pubads.setTargeting(key, adTags[key]);
            }
        }

        // Set Krux Tags
        let kruxTags = this.getKruxTags();
        Object.keys(kruxTags).forEach(function (key) {
            pubads.setTargeting(key, kruxTags[key]);
        });

        //  Configure settings and services
        if (enableLazyLoad === true) {
            // Enable lazy-loading for all ad slots
            pubads.enableLazyLoad({
                fetchMarginPercent: 50, // Fetch ads within 0.5 viewports
                renderMarginPercent: 0, // Render slots as soon as they enter the viewport
                mobileScaling: 2.0 // Double margins on mobile devices
            });
            pubads.setCentering(true);
        } else {
            pubads.collapseEmptyDivs();
            pubads.enableSingleRequest();
        }

        if (memberId) {
            pubads.setPublisherProvidedId(memberId);
        }

        googletag.enableServices();

        //  Display Adverts
        for (let ad of adverts) {
            googletag.display(ad.targetId);
        }
    }
}